import { render, staticRenderFns } from "./ProductSheetBaseView.vue?vue&type=template&id=06187f7f"
import script from "./ProductSheetBaseView.vue?vue&type=script&lang=js"
export * from "./ProductSheetBaseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports